import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { i18n } from './i18n';
import {
  DEFAULT_LOCALE,
  loadLocaleMessages,
  type SupportedLocale,
} from './locales';
import './composables/useTheme'; // init du data-theme au boot
import './style.css';

const initialLocale = i18n.global.locale.value as SupportedLocale;

async function bootstrap() {
  // Si locale initiale != fr-CH, on la charge avant de mount
  if (initialLocale !== DEFAULT_LOCALE && initialLocale !== 'fr-CH') {
    try {
      const messages = await loadLocaleMessages(initialLocale);
      i18n.global.setLocaleMessage(initialLocale, messages as any);
    } catch (e) {
      console.warn(`[i18n] Failed to load locale ${initialLocale}, fallback to fr-CH`, e);
      i18n.global.locale.value = 'fr-CH';
    }
  }

  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', i18n.global.locale.value);
  }

  const app = createApp(App);
  app.use(createPinia());
  app.use(router);
  app.use(i18n);

  const brandName = import.meta.env.VITE_APP_BRAND_NAME || 'Stafflow Pro';
  document.title = brandName;

  app.mount('#app');
}

bootstrap();
